import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

// Permissions
import { can, getMenuItems, getUserRole } from "../../helpers/permissions"

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [props.router.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  // Obtenir les éléments de menu autorisés
  const allowedMenuItems = getMenuItems();

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>

            {allowedMenuItems.includes('dashboard') && (
              <li>
                <Link to="/dashboard" className="waves-effect">
                  <i className="mdi mdi-view-dashboard"></i>
                  <span>{props.t("Dashboard")}</span>
                </Link>
              </li>
            )}

            {(allowedMenuItems.includes('clients') ||
              allowedMenuItems.includes('projects') ||
              allowedMenuItems.includes('tickets') ||
              allowedMenuItems.includes('team') ||
              allowedMenuItems.includes('teams') ||
              allowedMenuItems.includes('meetings')) && (
                <li className="menu-title">Gestion des Tickets</li>
              )}

            {allowedMenuItems.includes('clients') && can('view_clients') && (
              <li>
                <Link to="/clients" className="waves-effect">
                  <i className="mdi mdi-account-group"></i>
                  <span>Clients</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('projects') && (
              <li>
                <Link to="/projets" className="waves-effect">
                  <i className="mdi mdi-briefcase-check"></i>
                  <span>Projets</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('tickets') && (
              <li>
                <Link to="/tickets" className="waves-effect">
                  <i className="mdi mdi-ticket-confirmation"></i>
                  <span>
                    {getUserRole() === 'collaborateur' ? 'Mes tickets' :
                      (getUserRole() === 'admin' || getUserRole() === 'manager') ? 'Tous les tickets' : 'Tickets'}
                  </span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('my_tickets') && (getUserRole() === 'admin' || getUserRole() === 'manager') && (
              <li>
                <Link to="/my-tickets" className="waves-effect">
                  <i className="mdi mdi-account-check-outline"></i>
                  <span>Mes tickets</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('ticket_requests') && (
              <li>
                <Link to="/ticket-requests" className="waves-effect">
                  <i className="mdi mdi-clipboard-list"></i>
                  <span>Demandes de tickets</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('my_ticket_requests') && (
              <li>
                <Link to="/my-ticket-requests" className="waves-effect">
                  <i className="mdi mdi-clipboard-text"></i>
                  <span>Mes demandes</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('my_projects') && (
              <li>
                <Link to="/projets" className="waves-effect">
                  <i className="mdi mdi-folder-account"></i>
                  <span>Mes projets</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('team') && can('view_team') && (
              <li>
                <Link to="/team" className="waves-effect">
                  <i className="mdi mdi-account-switch"></i>
                  <span>Membres</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('teams') && can('view_teams') && (
              <li>
                <Link to="/teams" className="waves-effect">
                  <i className="mdi mdi-google-circles-extended"></i>
                  <span>Équipes</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('meetings') && (
              <li>
                <Link to="/meetings" className="waves-effect">
                  <i className="mdi mdi-video"></i>
                  <span>Réunions</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('points') && (
              <li>
                <Link to="/points" className="waves-effect">
                  <i className="mdi mdi-star"></i>
                  <span>Points de récompense</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('point_rates') && (
              <li>
                <Link to="/point-rates" className="waves-effect">
                  <i className="mdi mdi-currency-usd"></i>
                  <span>Grille Tarifaire</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('calendar') && (
              <li>
                <Link to="/calendar" className=" waves-effect">
                  <i className="mdi mdi-calendar-check"></i>
                  <span>{props.t("Calendar")}</span>
                </Link>
              </li>
            )}

            {allowedMenuItems.includes('whatsapp_settings') && can('view_whatsapp_settings') && (
              <>
                <li className="menu-title text-uppercase">Paramètres</li>
                <li>
                  <Link to="/whatsapp-settings" className="waves-effect">
                    <i className="mdi mdi-whatsapp"></i>
                    <span>Configuration WhatsApp</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
